import "./chunk-UAPTAAOL.js";
import "./chunk-R2NSDVWV.js";

// src/contracts.ts
import fs from "fs";
import path from "path";
function mergeABIs(abi1, abi2) {
  const namesUsed = {};
  const newABI = [];
  for (const fragment of abi1) {
    namesUsed[fragment.name] = true;
    newABI.push(fragment);
  }
  for (const fragment of abi2) {
    if (!namesUsed[fragment.name]) {
      namesUsed[fragment.name] = true;
      newABI.push(fragment);
    }
  }
  return newABI;
}
function loadContracts(folderOrFile) {
  if (fs.statSync(folderOrFile).isDirectory()) {
    return loadContractsFromFolder(folderOrFile);
  } else {
    return loadContractsFromFile(folderOrFile);
  }
}
function loadContractsFromFile(file) {
  let contractSTR = fs.readFileSync(file, "utf-8");
  if (contractSTR.startsWith("export default {") && contractSTR.endsWith("} as const;")) {
    contractSTR = contractSTR.slice(15, -10);
  }
  const contracts = JSON.parse(contractSTR);
  return {
    chainId: contracts.chainId,
    contracts: Object.keys(contracts.contracts).map(
      (name) => contracts.contracts[name]
    ),
    genesisHash: contracts.genesisHash
  };
}
function loadContractsFromFolder(folder) {
  const contractsAdded = {};
  const contractsData = [];
  const files = fs.readdirSync(folder);
  let genesisHash = void 0;
  let chainId = void 0;
  for (const file of files) {
    if (file === ".chainId") {
      chainId = fs.readFileSync(path.join(folder, file), "utf8");
      continue;
    }
    if (file === ".chain") {
      const str = fs.readFileSync(path.join(folder, file), "utf8");
      const { chainId: chainIdFromFile, genesisHash: genesisHashFromFile } = JSON.parse(str);
      chainId = chainIdFromFile;
      genesisHash = genesisHashFromFile;
      continue;
    }
    if (!file.endsWith(".json")) {
      continue;
    }
    const content = fs.readFileSync(path.join(folder, file), "utf8");
    const deployment = JSON.parse(content);
    if (!deployment.address) {
      continue;
    }
    const added = contractsAdded[deployment.address];
    const startBlock = deployment.receipt?.blockNumber ? typeof deployment.receipt?.blockNumber === "string" ? parseInt(deployment.receipt?.blockNumber.slice(2), 16) : deployment.receipt?.blockNumber : void 0;
    if (added) {
      if (startBlock) {
        if (!contractsData[added.index].startBlock || contractsData[added.index].startBlock > startBlock) {
          contractsData[added.index].startBlock = startBlock;
        }
      }
      contractsData[added.index].abi = mergeABIs(contractsData[added.index].abi, deployment.abi);
    } else {
      contractsData.push({
        address: deployment.address,
        abi: deployment.abi,
        startBlock
      });
      contractsAdded[deployment.address] = { index: contractsData.length - 1 };
    }
  }
  if (!chainId || isNaN(parseInt(chainId))) {
    throw new Error(`invalid chainId: ${chainId}`);
  }
  return {
    chainId,
    contracts: contractsData,
    genesisHash
  };
}

// src/javascript.ts
function filterOutFieldsFromObject(obj, fields) {
  const keys = Object.keys(obj);
  const newObj = {};
  for (const key of keys) {
    if (fields.includes(key)) {
      continue;
    }
    newObj[key] = obj[key];
  }
  return newObj;
}
function filterOutUnderscoreFieldsFromObject(obj) {
  const keys = Object.keys(obj);
  const newObj = {};
  for (const key of keys) {
    if (key.startsWith("_")) {
      continue;
    }
    newObj[key] = obj[key];
  }
  return newObj;
}
function clean(obj) {
  return filterOutUnderscoreFieldsFromObject(obj);
}
function removeUndefinedValuesFromObject(obj) {
  Object.keys(obj).forEach((key) => obj[key] === void 0 ? delete obj[key] : {});
  return obj;
}

// ../ethereum-indexer/dist/index.js
import { logs } from "named-logs";
import { logs as logs2 } from "named-logs";
var namedLogger = logs("ethereum-utils");
function normalizeAsArray(obj) {
  if (obj === null) {
    return null;
  }
  if (Array.isArray(obj)) {
    return obj.map((v) => normalizeAsArray(v));
  } else if (typeof obj === "object") {
    const arr = [];
    const keys = Object.keys(obj).sort();
    for (const key of keys) {
      const value = obj[key];
      if (value) {
        arr.push([key, normalizeAsArray(value)]);
      }
    }
    return arr;
  } else {
    return obj;
  }
}
function simple_hash(obj) {
  const str = typeof obj === "string" ? obj : JSON.stringify(normalizeAsArray(obj)).replace(/\s+/g, "");
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash &= hash;
  }
  const result = new Uint32Array([hash])[0].toString(36);
  return result;
}
var namedLogger2 = logs2("ethereum-indexer");

// src/indexer.ts
function formatLastSync(lastSync) {
  return filterOutFieldsFromObject(lastSync, ["_rev", "_id", "batch"]);
}
function contextFilenames(context) {
  const configHash = "config" in context && context.config ? simple_hash(context.config) : void 0;
  const networkString = `${context.source.chainId}${(context.source.chainId == "1337" || context.source.chainId == "31337") && context.source.genesisHash ? `-${context.source.genesisHash}` : ""}`;
  const prefix = `${networkString}${configHash ? `-${configHash}` : ``}${context.version ? `-${context.version}` : ``}`;
  const stateFile = `${prefix}-state.json`;
  const lastSyncFile = `${prefix}-lastSync.json`;
  return { stateFile, lastSyncFile };
}
export {
  clean,
  contextFilenames,
  filterOutFieldsFromObject,
  filterOutUnderscoreFieldsFromObject,
  formatLastSync,
  loadContracts,
  loadContractsFromFile,
  loadContractsFromFolder,
  removeUndefinedValuesFromObject
};
